import { render, staticRenderFns } from "./DcardNott.vue?vue&type=template&id=18a9fca8&scoped=true&"
import script from "./DcardNott.vue?vue&type=script&lang=js&"
export * from "./DcardNott.vue?vue&type=script&lang=js&"
import style0 from "./DcardNott.vue?vue&type=style&index=0&id=18a9fca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9fca8",
  null
  
)

export default component.exports